export const alertSources = [
  {
    id: 'nws',
    label: 'NWS',
    providerValues: ['National Weather Service', 'Custom Weather'],
  },
  {
    id: 'fema',
    label: 'FEMA IPAWS',
    alertSource: 'fema',
  },
  {
    id: 'fusion',
    label: 'Overwatch Fusion +',
    providerValues: ['Fusion'],
  },
];

export const DEFAULT_SELECTED_ALERT_SOURCES = [];
